import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';

export default function InfoTabView() {
    ViewBase.call(this);

    let startingPoints = [];
    let dwellTimes = {};
    let filter = {};

    let loadStartingPoints = () => {
        aiJpoModel.getStartingPoints({
            countryCode: filter.countryCode,
            bu: filter.bu
        })
            .then((result) => {
                startingPoints = result || [];
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    let loadDwellTimes = () => {
        aiJpoModel.getDwellTimes({
            countryCode: filter.countryCode,
            bu: filter.bu
        })
            .then((result) => {
                dwellTimes = result || {};
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    return {
        oninit: ({ attrs }) => {
            filter = attrs.filter;
            loadStartingPoints();
            loadDwellTimes();
        },
        onupdate: ({ attrs }) => {
            if (attrs.searchVersion !== filter._searchVersion) {
                filter = attrs.filter;
                filter._searchVersion = attrs.searchVersion;
                loadStartingPoints();
                loadDwellTimes();
            }
        },
        view: () => {
            return [
                // Starting Points
                m('.card.mb-3',
                    m('.card-header',
                        m('h6.mb-0', languageModel.getText('', 'Starting Points'))
                    ),
                    m('.card-body',
                        m('.table-responsive',
                            m('table.table.table-bordered',
                                m('thead.thead-bggrey',
                                    m('tr.align-middle', [
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Zone / Starting Point')),
                                        m('th', { scope: 'col', style: 'width: 150px;' }, languageModel.getText('', 'Latitude')),
                                        m('th', { scope: 'col', style: 'width: 150px;' }, languageModel.getText('', 'Longitude')),
                                    ])
                                ),
                                m('tbody',
                                    startingPoints.length === 0 &&
                                        m('tr.align-middle',
                                            m('td', { colspan: '3' }, languageModel.getText('', 'No records found.'))
                                        ),
                                    startingPoints.map((sp) =>
                                        m('tr', [
                                            m('td', sp.startingPoint || sp.zoneName),
                                            m('td.text-end', sp.latitude != null ? Number(sp.latitude).toFixed(6) : ''),
                                            m('td.text-end', sp.longitude != null ? Number(sp.longitude).toFixed(6) : ''),
                                        ])
                                    )
                                )
                            )
                        )
                    )
                ),

                // Dwell Times
                m('.card',
                    m('.card-header',
                        m('h6.mb-0', languageModel.getText('', 'Dwell Times by Grade'))
                    ),
                    m('.card-body',
                        m('.row',
                            ['A', 'B', 'C', 'D', 'E'].map((grade) =>
                                m('.col-6.col-md',
                                    m('.dwell-card', [
                                        m('.dwell-label', 'Grade ' + grade),
                                        m('.dwell-value', dwellTimes[grade] ?? 0),
                                        m('.dwell-unit', languageModel.getText('', 'minutes'))
                                    ])
                                )
                            )
                        )
                    )
                )
            ];
        }
    };
}
